<template>
	<div class="game-demo" v-if="game">
		<div class="game-demo__container">
			<iframe class="game-demo__iframe" :src="src"></iframe>
		</div>
	</div>
</template>

<script>

export default {
	name: 'GameDemo',
	components: {
	},
	data () {
		return {
		}
	},
	props: {
		game: Object
	},
	computed: {
		src: function()
		{
			var self = this;
			return self.$root.getGameDemo(self.game);
		}
	},
	created: function()
	{
	},
	mounted: function()
	{
	},
	methods: {
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".game-demo";
	#{$c}
	{
		max-width: 100%;
		background-color: palette(white);
		box-shadow: 0 1px 4px rgba(0,0,0,0.13);

		&__container
		{
			position: relative;
			display: flex;
			flex-wrap: nowrap;
			align-items: center;
			justify-content: center;

			&:before
			{
				content: "";
				display: block;
				width: 0;
				padding-top: 100% * (562/760);
			}
		}

		&__iframe
		{
			@include extend(absolute-fill);
			border: 0;

			// iOS fix for iframes
			height: 0;
			max-height: 100%;
			max-width: 100%;
			min-height: 100%;
			min-width: 100%;
			width: 0;
    }
	}

</style>



// WEBPACK FOOTER //
// src/components/molecules/GameDemo.vue